<template>
  <el-row type="flex" justify="center" style="margin-top: 40px;">
    <el-col :span="8">
      <el-card v-loading="loading" class="box-card">
        <div slot="header" class="clearfix">
          <span style="font-size: 18px; font-weight: bold;">Gift Card Report</span>
        </div>
        <el-form label-position="left" :model="form" :rules="rules" ref="form" label-width="140px">
          <el-form-item label="Shopify Store" prop="region">
            <el-tooltip content="Select the store/region" placement="top">
              <el-select v-model="form.region" placeholder="Select Store" style="width: 100%;">
                <el-option
                    v-for="item in regionOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
              </el-select>
            </el-tooltip>
          </el-form-item>
          <el-form-item>
            <el-button :loading="loading" :disabled="loading" type="primary" @click="submitForm('form')">Generate
            </el-button>
            <el-button :disabled="loading" @click="resetForm('form')" style="margin-left: 10px;">Reset</el-button>
          </el-form-item>
        </el-form>
      </el-card>
    </el-col>
  </el-row>
</template>

<script>
import {notify} from '../../utils';
import axios from '../../repositories';

const defaultRegionOptions = [
  {value: 'ca', label: 'CA'},
  {value: 'usa', label: 'USA'},
];

export default {
  name: 'GiftCardReport',
  data() {
    return {
      form: {
        region: '',
      },
      rules: {
        region: {required: true, message: 'Required', trigger: 'change'},
      },
      regionOptions: defaultRegionOptions,
      loading: false,
    };
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loading = true;
          axios.get('/finance/reports/gift-card', {
            params: this.form,
            validateStatus: () => true, // Accept all status codes for custom handling
          }).then((response) => {
            if (response.status === 202) {
              notify(response.data.message, 'success');
            } else if (response.status === 400 && response.data.errors) {
              notify(response.data.errors, 'danger');
            } else {
              notify(response.data.message || 'Unexpected error', 'danger');
            }
          }).catch((err) => {
            notify(err.response?.data?.message || err.message, 'danger');
          }).finally(() => {
            this.loading = false;
          });
        } else {
          notify('Please fill out the form.', 'danger');
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
  },
};
</script>

<style scoped>
.box-card {
  margin-top: 20px;
}
</style>